import { isArray } from 'lodash'

export const convertTagsToFlattenObjectArray = (tags) => {
  return isArray(tags?.value) ? tags.value.map(tag => tag.label) : tags.value
}
export const tagsValueGetter = (params) => params.data?.tags?.map(tag => tag.label)?.join(', ')
